import React from 'react';
import { classNames } from '@vedantuadmin/wave-ui';

import styles from './Loader.module.scss';

const Loader = () => (
  <div
    className={classNames(
      'flex-center t-0 l-0',
      'fixed w-1/1-vw h-1/1-vh',
      'z-100',
      'bg-white-0',
    )}
  >
    <svg
      className={classNames(
        `${styles.circleLoader}`,
        'w-64 h-64',
      )}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50%" cy="50%" r="40%" fill="transparent" stroke="red" />
    </svg>
  </div>

);

export default Loader;